export const Constants = {
  XFADE_DURATION: 300,
  EMPTY_VALUE: "—",
  DEBOUNCE_DEFAULT: 350,
  APP_NAME: "Nexus Hyperfabric",
  BRANDED_APP_NAME: "Cisco Nexus Hyperfabric",
  TIME_SERIES_DATA_LIMIT: 5000,
  FABRIC_CANDIDATE_PAGINATION_LIMIT: 1000,
  GIG_SPEED: "G",
  SESSION_LOGOUT: new Event("SessionLogout"),
  PORT_HIGHLIGHT_CHANGE: new Event("portHighlightChange"),
  MAX_HARDWARE_SET_QUANTITY: 64,
  /** Null character as line break from backend API */
  CANDIDATE_DIFF_API_LINE_BREAK: "\u0000",
  /** Standard line break for diff viewing */
  CANDIDATE_DIFF_LINE_BREAK: "\n",
  WILDCARD: "*",
  NA: "N/A",
  SYSTEM_VRF_NAME: "System VRF"
};
